import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export interface LoginMicroFrontendProps extends SpecificMicroFrontendProps {
  onLoginSuccessful?: (permissions: any) => void;
  onMobileAppLoginSuccessful?: (data: any) => void;
  isAppMobile?: boolean;
}

export const LoginMicroFrontend: FC<LoginMicroFrontendProps> = ({
  entryPointUrl,
  onLoginSuccessful,
  onMobileAppLoginSuccessful,
  isAppMobile,
  isMobile,
  isTablet,
  isSmartTV,
  ...props
}) => {
  // Determine which exposed path to use based on device type
  const exposedPath = isAppMobile ? constants.MFE_MOBILE_EXPOSED_PATH : constants.MFE_EXPOSED_PATH;

  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_LOGIN_NAME}
      exposedPath={exposedPath}
      params={{ onLoginSuccessful, onMobileAppLoginSuccessful }}
      isAppMobile={isAppMobile}
      isMobile={isMobile}
      isTablet={isTablet}
      isSmartTV={isSmartTV}
      {...props}
    />
  );
};
